import Vue from 'vue'
import Vuex from 'vuex'
import { EPL } from './eplmodule'
import { SIGN } from './signmodule'

Vue.use(Vuex)

export interface RootState {
  epl: EPL,
  sign: SIGN
}

export default new Vuex.Store<RootState>({})
